import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedContent from './components/FeaturedContent';
import LatestUpdates from './components/LatestUpdates';
import MembershipBenefits from './components/MembershipBenefits';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import { Link } from 'react-router-dom';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '91麻豆',
  url: 'https://clinicvip.cn/',
  description: '91麻豆是备受用户追捧的正版高清视频内容平台，提供海量优质原创资源、流畅播放体验与安全稳定的访问渠道。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://clinicvip.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '91麻豆',
  url: 'https://clinicvip.cn/',
  description: '正版高清视频内容平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9191',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="91麻豆官方平台——正版高清内容一站直达"
        description="91麻豆是备受用户追捧的正版高清视频内容平台，提供海量优质原创资源、流畅播放体验与安全稳定的访问渠道。无论新用户还是老会员，91麻豆都能满足您对高品质娱乐内容的全部需求，立即探索专属福利与最新资源。"
        keywords="91麻豆,91麻豆官网入口,91麻豆高清视频,91麻豆最新地址,91麻豆会员福利,91麻豆原创内容,91麻豆安全访问"
        canonicalUrl="https://clinicvip.cn/"
        schemaData={{ ...homepageSchema, ...orgSchema }}
      />

      <HeroSection />

      <CategoryGrid />

      <FeaturedContent />

      <MembershipBenefits />

      <LatestUpdates />

      <TestimonialsSection />

      <CTA />

      <FAQSection />
    </>
  );
}

function CTA() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20abstract%20background%20with%20soft%20bokeh%20lights%20and%20gradients%2C%20elegant%20dark%20amber%20and%20crimson%20tones%2C%20luxurious%20atmosphere%2C%20sophisticated%20and%20artistic%20composition&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          开启您的高清娱乐之旅
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl mx-auto">
          加入5000万用户的选择，畅享10万+正版高清内容，随时随地，想怎么看就怎么看
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            立即加入会员
          </Link>
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            浏览内容库
          </Link>
        </div>
      </div>
    </section>
  );
}